import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion, easeOut } from "framer-motion";

import { Typography, Button } from '@mui/material';
import sessionstorage from 'sessionstorage';

import Classes from "./SectionA.module.css";
import '../Home.css'

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Navbar from './Navbar/Navbar';

function SectionA() {
  const [width, setWidth] = useState(window.innerWidth);
  const { user } = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const navigateToSignup = () => {
    navigate('/join');
  }

  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <>
      <section id='home' className={Classes.home} >
        <div className={Classes.customBox}>
          <motion.div
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: .4, // Total duration of the animation
              ease: easeOut, // Custom easing curve
              delay: 1.2 // Delay before animation starts
            }}>
            <Navbar />
          </motion.div>
          <motion.div
            whileTap={{ scale: 0.90 }}
            initial={{ opacity: 0, y: 250 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: .4,
              ease: easeOut,
              delay: 1
            }}
          >
            <motion.div
              whileTap={{ scale: 0.95 }}
              className={Classes.miniBanner}
              onClick={navigateToSignup}
            >
              <button type='button' > <h5>New</h5> </button>
              <h5>Discover Top Mentors For You {'>'}</h5>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 250 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: .4,
              ease: easeOut,
              delay: 1.2
            }}
          >
            <h1 className={Classes.Txt1} >
              Start Ending Career Fear Today
            </h1>

          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 150 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: .4, // Total duration of the animation
              ease: easeOut, // Custom easing curve
              delay: 1.5 // Delay before animation starts
            }}
          >
            <h5 className={Classes.Txt2} >
              Whether you’re unsure where to start or ready to go all in
              Mentr <br /> connects  you with people who’ve been there.
            </h5>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: .4, // Total duration of the animation
              ease: easeOut, // Custom easing curve
              delay: 1.8 // Delay before animation starts
            }}
            whileTap={{ scale: 0.90 }}
            className={Classes.home_btns_con}
          >
            <div className={Classes.home_btns}>
              <motion.div
                whileTap={{ scale: 0.97 }}
                whileHover={{ scale: 1.03 }}
              >
                <button className={Classes.startBtn} onClick={navigateToSignup} > <h5>Get Started</h5> </button>
              </motion.div>
            </div>
          </motion.div>

        </div>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.4,
            ease: easeOut,
            delay: 2
          }}
          className={Classes.demoImageContainer}
        >
          <div className={Classes.demoImageWrap}>
            <LazyLoadImage
              src='/assets/images/demo-image-blue.webp'
              className={Classes.demoImage}
              alt='demo image'
              loading="eager"
              decoding="async"
              draggable={false}
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: .4, // Total duration of the animation
            ease: easeOut, // Custom easing curve
            delay: 1 // Delay before animation starts
          }} className={Classes.gradientBackground} >
        </motion.div>
      </section >
    </>
  );
}

export default SectionA;